<template>
  <div id="switcher-theme-header" @click="toggleTheme">
    <svg
      :class="['svg-icon', isLightTheme ? 'light-icon' : 'dark-icon']"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_38_92)">
        <path
          d="M8.15625 2.53125V1.40625C8.15625 1.18247 8.24514 0.967862 8.40338 0.809629C8.56161 0.651395 8.77622 0.5625 9 0.5625C9.22378 0.5625 9.43839 0.651395 9.59662 0.809629C9.75486 0.967862 9.84375 1.18247 9.84375 1.40625V2.53125C9.84375 2.75503 9.75486 2.96964 9.59662 3.12787C9.43839 3.28611 9.22378 3.375 9 3.375C8.77622 3.375 8.56161 3.28611 8.40338 3.12787C8.24514 2.96964 8.15625 2.75503 8.15625 2.53125ZM13.7812 9C13.7812 9.94564 13.5008 10.87 12.9755 11.6563C12.4501 12.4426 11.7034 13.0554 10.8297 13.4173C9.95605 13.7792 8.9947 13.8739 8.06722 13.6894C7.13975 13.5049 6.28782 13.0495 5.61915 12.3809C4.95048 11.7122 4.49511 10.8602 4.31062 9.93278C4.12613 9.0053 4.22082 8.04395 4.5827 7.17029C4.94458 6.29664 5.55741 5.54991 6.34368 5.02454C7.12995 4.49917 8.05436 4.21875 9 4.21875C10.2677 4.22005 11.483 4.72421 12.3794 5.62058C13.2758 6.51696 13.7799 7.73233 13.7812 9ZM12.0938 9C12.0938 8.38811 11.9123 7.78997 11.5724 7.2812C11.2324 6.77244 10.7492 6.37591 10.1839 6.14175C9.61862 5.90759 8.99657 5.84632 8.39644 5.9657C7.79631 6.08507 7.24506 6.37972 6.81239 6.81239C6.37972 7.24506 6.08507 7.79631 5.9657 8.39644C5.84632 8.99657 5.90759 9.61862 6.14175 10.1839C6.37591 10.7492 6.77244 11.2324 7.2812 11.5724C7.78997 11.9123 8.38811 12.0938 9 12.0938C9.82023 12.0928 10.6066 11.7666 11.1866 11.1866C11.7666 10.6066 12.0928 9.82023 12.0938 9ZM3.6218 4.8157C3.70028 4.89419 3.79346 4.95645 3.896 4.99892C3.99855 5.0414 4.10846 5.06326 4.21945 5.06326C4.33045 5.06326 4.44036 5.0414 4.5429 4.99892C4.64545 4.95645 4.73862 4.89419 4.81711 4.8157C4.8956 4.73722 4.95785 4.64404 5.00033 4.5415C5.0428 4.43895 5.06467 4.32904 5.06467 4.21805C5.06467 4.10705 5.0428 3.99714 5.00033 3.8946C4.95785 3.79205 4.8956 3.69888 4.81711 3.62039L3.97336 2.77664C3.81485 2.61813 3.59987 2.52908 3.3757 2.52908C3.15154 2.52908 2.93656 2.61813 2.77805 2.77664C2.61954 2.93515 2.53049 3.15013 2.53049 3.3743C2.53049 3.59846 2.61954 3.81344 2.77805 3.97195L3.6218 4.8157ZM3.6218 13.1829L2.77805 14.0266C2.69956 14.1051 2.6373 14.1983 2.59483 14.3008C2.55235 14.4034 2.53049 14.5133 2.53049 14.6243C2.53049 14.7353 2.55235 14.8452 2.59483 14.9477C2.6373 15.0503 2.69956 15.1435 2.77805 15.222C2.93656 15.3805 3.15154 15.4695 3.3757 15.4695C3.4867 15.4695 3.59661 15.4476 3.69915 15.4052C3.8017 15.3627 3.89487 15.3004 3.97336 15.222L4.81711 14.3782C4.97562 14.2197 5.06467 14.0047 5.06467 13.7805C5.06467 13.5564 4.97562 13.3414 4.81711 13.1829C4.6586 13.0244 4.44362 12.9353 4.21945 12.9353C3.99529 12.9353 3.78031 13.0244 3.6218 13.1829ZM13.7812 5.0625C13.8921 5.06259 14.0019 5.04084 14.1043 4.99849C14.2067 4.95614 14.2998 4.89403 14.3782 4.8157L15.222 3.97195C15.3004 3.89347 15.3627 3.80029 15.4052 3.69775C15.4476 3.5952 15.4695 3.48529 15.4695 3.3743C15.4695 3.2633 15.4476 3.15339 15.4052 3.05085C15.3627 2.9483 15.3004 2.85513 15.222 2.77664C15.1435 2.69816 15.0503 2.6359 14.9477 2.59342C14.8452 2.55095 14.7353 2.52908 14.6243 2.52908C14.5133 2.52908 14.4034 2.55095 14.3008 2.59342C14.1983 2.6359 14.1051 2.69816 14.0266 2.77664L13.1829 3.62039C13.0642 3.7384 12.9833 3.88906 12.9504 4.05319C12.9176 4.21732 12.9343 4.38751 12.9984 4.54212C13.0626 4.69672 13.1713 4.82875 13.3107 4.92142C13.4501 5.01408 13.6139 5.06319 13.7812 5.0625ZM14.3782 13.1843C14.2197 13.0258 14.0047 12.9367 13.7805 12.9367C13.5564 12.9367 13.3414 13.0258 13.1829 13.1843C13.0244 13.3428 12.9353 13.5578 12.9353 13.782C12.9353 14.0061 13.0244 14.2211 13.1829 14.3796L14.0266 15.2234C14.1851 15.3819 14.4001 15.4709 14.6243 15.4709C14.8485 15.4709 15.0634 15.3819 15.222 15.2234C15.3805 15.0649 15.4695 14.8499 15.4695 14.6257C15.4695 14.4015 15.3805 14.1866 15.222 14.028L14.3782 13.1843ZM3.375 9C3.375 8.77622 3.28611 8.56161 3.12787 8.40338C2.96964 8.24514 2.75503 8.15625 2.53125 8.15625H1.40625C1.18247 8.15625 0.967862 8.24514 0.809629 8.40338C0.651395 8.56161 0.5625 8.77622 0.5625 9C0.5625 9.22378 0.651395 9.43839 0.809629 9.59662C0.967862 9.75486 1.18247 9.84375 1.40625 9.84375H2.53125C2.75503 9.84375 2.96964 9.75486 3.12787 9.59662C3.28611 9.43839 3.375 9.22378 3.375 9ZM9 14.625C8.77622 14.625 8.56161 14.7139 8.40338 14.8721C8.24514 15.0304 8.15625 15.245 8.15625 15.4688V16.5938C8.15625 16.8175 8.24514 17.0321 8.40338 17.1904C8.56161 17.3486 8.77622 17.4375 9 17.4375C9.22378 17.4375 9.43839 17.3486 9.59662 17.1904C9.75486 17.0321 9.84375 16.8175 9.84375 16.5938V15.4688C9.84375 15.245 9.75486 15.0304 9.59662 14.8721C9.43839 14.7139 9.22378 14.625 9 14.625ZM16.5938 8.15625H15.4688C15.245 8.15625 15.0304 8.24514 14.8721 8.40338C14.7139 8.56161 14.625 8.77622 14.625 9C14.625 9.22378 14.7139 9.43839 14.8721 9.59662C15.0304 9.75486 15.245 9.84375 15.4688 9.84375H16.5938C16.8175 9.84375 17.0321 9.75486 17.1904 9.59662C17.3486 9.43839 17.4375 9.22378 17.4375 9C17.4375 8.77622 17.3486 8.56161 17.1904 8.40338C17.0321 8.24514 16.8175 8.15625 16.5938 8.15625Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_38_92">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <div
      class="switcher"
      :class="{ 'justify-end': !isLightTheme, 'justify-start': !isLightTheme }"
    >
      <div class="toogle"></div>
    </div>

    <svg
      :class="['svg-icon', isLightTheme ? 'light-icon' : 'dark-icon']"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.883 2.50801L10.812 3.09376L11.883 3.67951L12.4688 4.75051L13.0545 3.67951L14.1255 3.09376L13.0545 2.50801L12.4688 1.43701L11.883 2.50801ZM7.809 3.11851C6.82673 3.31782 5.91004 3.76002 5.14264 4.40473C4.37523 5.04944 3.78156 5.87613 3.41583 6.8093C3.05009 7.74248 2.92396 8.7524 3.04894 9.74686C3.17392 10.7413 3.54603 11.6886 4.1313 12.5023C4.71656 13.3159 5.49634 13.97 6.39941 14.4048C7.30248 14.8396 8.30008 15.0412 9.30112 14.9912C10.3022 14.9413 11.2747 14.6414 12.13 14.1188C12.9854 13.5963 13.6961 12.8679 14.1975 12C12.4164 11.9862 10.713 11.2689 9.45843 10.0045C8.20389 8.74014 7.49995 7.03116 7.5 5.25001C7.5 4.51501 7.59825 3.79726 7.809 3.11851ZM1.5 9.00001C1.5 4.85776 4.85775 1.50001 9 1.50001H10.3005L9.6495 2.62501C9.21525 3.37501 9 4.26751 9 5.25001C8.99989 6.02522 9.17145 6.79084 9.50237 7.49187C9.83329 8.19291 10.3154 8.81196 10.9139 9.30456C11.5125 9.79716 12.2128 10.1511 12.9644 10.3409C13.716 10.5308 14.5003 10.5518 15.261 10.4025L16.5225 10.1573L16.1152 11.3768C15.1215 14.3528 12.3127 16.5 9 16.5C4.85775 16.5 1.5 13.1423 1.5 9.00001ZM15.375 4.81201L16.0605 6.06451L17.313 6.75001L16.0605 7.43551L15.375 8.68801L14.6895 7.43551L13.437 6.75001L14.6895 6.06451L15.375 4.81201Z"
        fill="black"
      />
    </svg>
  </div>
</template>
<script>
export default {
  name: "ThemeSwitcherHeader",
  computed: {
    isLightTheme() {
      return !this.$store.getters.isDarkTheme;
    },
  },
  mounted() {
    this.$store.dispatch("initializeTheme");
  },
  methods: {
    toggleTheme() {
      this.$store.dispatch("toggleTheme");
    },
  },
};
</script>

<style lang="scss" scoped>
#switcher-theme-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;

  .switcher {
    display: flex;
    align-items: center;
    width: 40px;
    height: 22px;
    border: 1.5px solid var(--font-color);
    transition: all 0.3s ease-in-out;

    border-radius: 100px;
    padding: 4px;

    .toogle {
      height: 14px;
      width: 14px;
      background-color: var(--font-color);
      border-radius: 50%;
      transition: all 0.3s ease-in-out;
    }
  }

  .justify-end {
    justify-content: flex-end;
  }

  .justify-start {
    justify-content: flex-start;
  }
}
</style>
